import {
  GET_CUSTOM_LIST_BY_TYPE,
  GET_CUSTOM_LIST_BY_TYPE_SUCCESS,
  CREATE_CUSTOM_LIST,
  PATCH_CUSTOM_LIST,
} from "./constants"
//****************************** Custom List ******************************* */
export const getCustomListByTypeAction = payload => ({
  type: GET_CUSTOM_LIST_BY_TYPE,
  payload: payload,
})

export const getCustomListByTypeSuccessAction = payload => ({
  type: GET_CUSTOM_LIST_BY_TYPE_SUCCESS,
  payload: payload,
})

export const createCustomListAction = payload => ({
  type: CREATE_CUSTOM_LIST,
  payload: payload,
})

export const patchCustomListAction = payload => ({
  type: PATCH_CUSTOM_LIST,
  payload: payload,
})
